<template>
  <v-container fluid>
    <Datatable
      v-if="$_HASPERMISSION(NAME, getSession.user.id_tipo_utilizador)"
      :TableItems="TableItems"
      :TableHeaders="TableHeaders"
      :FormFields="FormFields"
      :TableActions="TableActions"
      :ModalNewText="ModalNewText"
      :ModalUpdateText="ModalUpdateText"
      :ModalDeleteText="ModalDeleteText"
      :DeleteDialogTitle="DeleteDialogTitle"
      :TableTitle="TableTitle"
      :Store="Store"
    />
  </v-container>
</template>
<script>
import { _MODELS } from "@/store/_MAIN"
const _NAME = "DONATIVO"
export default {
  components: {
    Datatable: () => import("@/components/Datatable")
  },
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    },
    TableItems() {
      return this.$store.getters[`${this.NAME}/getAll`].map(el => {
        return el
      })
    }
  },
  data: () => ({
    Store: "donativo",
    TableTitle: "Donativos",
    ModalNewText: "Novo donativo",
    ModalUpdateText: "Alterar donativo",
    DeleteDialogTitle: "",
    ModalDeleteText: "",
    TableActions: _MODELS[_NAME]._ACTIONS,
    FormFields: _MODELS[_NAME]._FIELDS,
    TableHeaders: _MODELS[_NAME]._HEADERS,
    NAME: _NAME.toLowerCase()
  })
}
</script>